<div class="add-payment bulk-payment">
  <div class="ui-g-12 p-zero dialog-header">
    <div class="send-dialog-heading flex-start-center">
      <i class="far fa-file-invoice-dollar pr-2"></i>
      <span>Bulk payment</span>
    </div>
    <i class="fal fa-times fa-sm dialog-close" (click)="closePaymentModal({})"></i>
  </div>

  <div class="dialog-body">
    <div class="ui-g">
      <!-- Payment details Section -->
      <ng-container *ngIf="isCustomerPaymentEnabled">
        <div class="ui-g-12 p-0">
          <p class="mb-2 font-bold pb-1 invoice-detail-title font-16">Payment details</p>
        </div>

        <div class="ui-g-12 p-0">
          <div class="ui-g-6 p-0 flex-start-center height-34">
            <app-radio-button id="bulk-pay-roa" class="mr-4" name="bulk-pay-type" label="ROA payment"
              styleClassLabel="font-seconday" [selectedValue]="bulkPaymentType" value="roa"
              (appChange)="handleRadioChange($event)">
            </app-radio-button>

            <app-radio-button id="bulk-pay-statement" class="mr-4" name="bulk-pay-type" label="Statment"
              styleClassLabel="font-seconday" [selectedValue]="bulkPaymentType" value="statement"
              (appChange)="handleRadioChange($event)">
            </app-radio-button>

            <div *ngIf="bulkPaymentType === 'statement'" class="width-200">
              <app-dropdown id="statements-dd" listId="statements-dd-list" class="width-100p" theme="primary"
                placeholder="Statement" field="name" [fontSize]="14" [listItemFontSize]="14" [floatingLabel]="false"
                [options]="statementList" [value]="statement" [isDropdownIconVisible]="true"
                (appSelect)="handleSelectStatement($event)">
              </app-dropdown>
            </div>
          </div>

          <div class="flex-end-center ui-g-6 p-0">
            <span class="p m-0 pr-2">Prior unapplied amount</span>
            <app-input id="prior-payment-amount" placeholder="$0.00" theme="primary" [fontSize]="13" [disabled]="true"
              [value]="unappliedAmount | currency: usd">
            </app-input>

            <span class="p m-0 pr-2 ml-5">Amount</span>
            <app-input id="payment-amount" placeholder="$0.00" theme="primary" [fontSize]="13"
              [selectTextOnFocus]="true" [isInvalid]="validate.amount" [errorMessage]="validate.amount"
              [hasHoverBorderBottom]="false" [allowDecimal]="true" [autoFocus]="focus.collectedAmount"
              [disabled]="isArchived" [hasHoverEffect]="false"
              [value]="focus.collectedAmount ? payment.collectedAmount : (payment.collectedAmount | currency: usd)"
              (appChange)="handleChange($event, 'collectedAmount')" (appFocus)="handleFocus('collectedAmount')"
              (appBlur)="handleBlur('collectedAmount')">
            </app-input>
          </div>
        </div>
      </ng-container>

      <!-- Invoices Section -->
      <div class="ui-g-12 p-0">
        <p class="mb-2 font-bold pb-1 invoice-detail-title font-16">Invoice details</p>
      </div>

      <!-- Date range filter &  Amount recieved -->
      <ng-container *ngIf="!isCustomerPaymentEnabled">
        <div class="ui-g-12 p-0 flex-between-center">
          <div class="flex-start-center ui-g-6 p-0">
            <app-dropdown theme="border" id="statements-dd" listId="statements-dd-list" class="width-100p"
              placeholder="Statement" field="name" [fontSize]="14" [listItemFontSize]="14" [floatingLabel]="false"
              [options]="statementList" [value]="statement" [isDropdownIconVisible]="true"
              (appSelect)="handleSelectStatement($event)">
            </app-dropdown>
          </div>

          <div class="flex-end-center ui-g-6 p-0">
            <span class="p m-0 pr-2">Prior unapplied amount</span>
            <app-input id="prior-payment-amount" placeholder="$0.00" theme="primary" [fontSize]="13" [disabled]="true"
              [value]="unappliedAmount | currency: usd">
            </app-input>

            <span class="p m-0 pr-2 ml-5">Amount</span>
            <app-input id="payment-amount" placeholder="$0.00" theme="primary" [fontSize]="13"
              [selectTextOnFocus]="true" [isInvalid]="validate.amount" [errorMessage]="validate.amount"
              [hasHoverBorderBottom]="false" [allowDecimal]="true" [autoFocus]="focus.collectedAmount"
              [disabled]="isArchived" [hasHoverEffect]="false"
              [value]="focus.collectedAmount ? payment.collectedAmount : (payment.collectedAmount | currency: usd)"
              (appChange)="handleChange($event, 'collectedAmount')" (appFocus)="handleFocus('collectedAmount')"
              (appBlur)="handleBlur('collectedAmount')">
            </app-input>
          </div>
        </div>
      </ng-container>

      <div *ngIf="isStateRestricted() && statementId" class="ui-g-12 p-0 mt-2 mb-1 font-12 ro-restricted-msg">
        <i class="fal fa-lock pr-1"></i>
        <span>
          This statement contains an RO that is currently being edited, therefore a bulk payment cannot be made.
        </span>
      </div>

      <!-- Statement invoices list -->
      <div class="ui-g-12 p-0 mb-4 mt-2" [ngClass]="{'mt-30': validateError == true}">
        <p-table class="statement-list" #dt [columns]="cols" [value]="statement?.invoices" [sortOrder]="1"
          [scrollable]="true" [lazy]="true">
          <ng-template pTemplate="header" let-columns>
            <tr class="statement-row-header">
              <th pSortableColumn="invCode" class="inv-code">
                Invoice #
              </th>

              <th pSortableColumn="vehicle" class="vehicle">
                Vehicle
              </th>

              <th *ngIf="!isRevenueRecognitionSettleEnabled" pSortableColumn="invoiceDate" class="invoice-date">
                Invoice date
              </th>

             
              <th *ngIf="isRevenueRecognitionSettleEnabled" pSortableColumn="finalizedDate" class="finalize-date">
                Finalize date
              </th>

              <th pSortableColumn="paymentStatus" class="payment-status">
                Status
              </th>

              <th pSortableColumn="totalOrderAmount" class="total-value">
                Total value
              </th>

              <th *ngIf="isCustomerPaymentEnabled" pSortableColumn="priorUnappliedPayment"
                class="prior-unapplied-payment">
                Prior unapplied payments
              </th>

              <th pSortableColumn="order" class="amount-remaning">
                Balance due
              </th>

              <th pSortableColumn="order" class="payment">
                New payment
              </th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-rowData let-columns="columns">
            <tr class="statement-grid-row" *ngIf="!isInvoiceLoading">
              <td *ngFor="let col of columns" [ngClass]="col.className">
                <!-- Invoice # -->
                <div *ngIf="col.field === 'invCode'" class="hover-underline pointer font-color"
                  (click)="openInvoice(rowData?._id)">
                  <p id="bulk-pay-inv-code" class="font-13 font-secondary-900 font-600 m-0 flex-between-center">
                    <span class="text-truncate" [pTooltip]="rowData[col.field]">
                      {{rowData[col.field]}}
                    </span>

                    <span [ngClass]="{ invisible: !rowData?.isAssociatedWithStatement }"
                      [pTooltip]="rowData?.associatedWarningTooltip">
                      <i class="fas fa-exclamation-triangle font-yellow"></i>
                    </span>
                  </p>
                  <i class="fal fa-lock lock-icon font-10 pr-1" *ngIf="rowData?.isRestricted"></i>
                  <span class="font-10 font-gray-45">RO#&nbsp;{{ rowData.code }}</span>
                </div>

                <!-- Vehicle -->
                <div id="bulk-pay-vehicle" *ngIf="col.field === 'vehicle'" class="text-truncate"
                  [pTooltip]="rowData[col.field]?.name">
                  {{ rowData[col.field]?.name }}
                </div>

                <!-- Invoice date -->
                <div *ngIf="!isRevenueRecognitionSettleEnabled" class="width-100p">
                  <div id="bulk-pay-invoice-date" *ngIf="col.field === 'invoiceDate'">
                    {{ rowData[col.field] | date: 'MMM d, yyyy' }}
                  </div>
                </div>

                <div *ngIf="isRevenueRecognitionSettleEnabled" class="width-100p">
                  <div id="bulk-pay-invoice-date" *ngIf="col.field === 'finalizeDate'">
                    {{ rowData[col.field] | date: 'MMM d, yyyy' }}
                  </div>
                </div>
                <!-- Status -->
                <div class="width-100p">
                  <div id="bulk-pay-payment-status" *ngIf="col.field === 'paymentStatus'">
                    {{ rowData[col.field] }}
                  </div>
                </div>

                <!-- Total value -->
                <div class="width-100p">
                  <div *ngIf="col.field === 'totalOrderAmount'" class="flex-column">
                    <span id="bulk-pay-total-order-amount">{{ rowData[col.field] || 0 | currency: usd }}</span>
                    <span class="font-gray-65 font-11">Paid: {{ rowData?.paid || 0 | currency: usd }}</span>
                  </div>
                </div>

                <!-- Prior unapplied payments -->
                <div *ngIf="isCustomerPaymentEnabled" class="width-100p">
                  <div *ngIf="col.field === 'priorUnappliedPayment'">
                    <span id="bulk-pay-prior-unapplied-payment" class="font-13 font-secondary-900">
                      {{ rowData?.priorPayment || 0 | currency: usd }}
                    </span>
                    <br />
                  </div>
                </div>

                <!-- Balance due -->
                <div class="width-100p">
                  <div *ngIf="col.field === 'amountRemaning'">
                    <span id="bulk-pay-amount-remaning" class="font-13 font-secondary-900">
                      {{ rowData?.amountRemainingAfterPriorPayment || 0 | currency: usd }}
                    </span>
                    <br />
                  </div>
                </div>

                <!-- New payment -->
                <div class="width-100p">
                  <div *ngIf="col.field === 'payment'">
                    <span id="bulk-pay-payment" class="font-13 font-secondary-900">
                      {{ focus.collectedAmount && rowData[col.field] == '.' ? (0 | currency: usd) : (rowData[col.field]
                      || 0 | currency: usd) }}
                    </span>
                    <br />
                  </div>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>

      <div class="ui-g-12 p-zero payment-details">
        <div class="ui-g-12 p-0 mb-3">
          <p class="mb-2 font-bold pb-1 invoice-detail-title font-16">Payment details</p>
        </div>
        <!-- Start Left panel -->
        <div class="ui-g-8 p-zero left-box">
          <!-- Invoices Code -->
          <div class="ui-g-12 p-0 mb-8px">
            <div class="flex-start-center field-wrapper mt-3">
              <div class="field-icon flex-center-center">
                <i class="far fa-file-alt"></i>
              </div>

              <div class="field-input">
                <app-input placeholder="Repair orders - RO" theme="primary" [disabled]="true" [floatingLabel]="true"
                  [value]="invoicesCodes"></app-input>
              </div>
            </div>
          </div>

          <!-- Payment Type -->
          <div class="ui-g-12 p-0 mb-5px">
            <div class="flex-start-center field-wrapper mt-3">
              <div class="field-input">
                <div class="ui-g-12 p-zero">
                  <p class="font-12 font-600 mb-4px float-left">Payment types*</p>
                </div>

                <div class="ui-g-12 p-zero" [ngClass]="{ 'payment-not-allowed': isArchived }">
                  <div class="d-flex mb-2">
                    <div id="bulk-pay-payment-type" *ngFor="let method of paymentTypes; let i = index"
                      class="payment-method-card text-center pointer" id="payment-method-{{ method.label }}" [ngClass]="{
                        'mr-2': i < paymentTypes.length - 1,
                        'disabled not-allowed': !paymentMethodsActive[method.value],
                        'active-card': method.value === activePayment?.value,
                        'disabled not-allowed': isArchived
                      }" (click)="activateMethodCard(method, 'true')">
                      <div class="payment-method-inner">
                        <i class="font-24 {{ method.icon }}"></i>
                        <p class="font-12 font-bold mb-0">{{ method.label }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- ChargeCard -->
          <div *ngIf="activePayment.value === 'card' && isPaymentGatewayConected && !paymentId"
            class="ui-g-12 p-0 mb-10px">
            <label class="font-12 font-600 mb-4px">
              <span>Charge Card*</span>
            </label>
          </div>
          <!-- sub buttons online entry -->
          <div class="ui-g-12 p-0 mb-10px p-zero paymentMethods"
            *ngIf="activePayment.value === 'card' && isPaymentGatewayConected && !paymentId"
            [ngClass]="{ disabled: isArchived || afterOnlinePayment }">
            <div class="ui-g-6 p-0 pr-2">
              <button id="OnlineCardEntryCheckBox" [value]="isOnlineCard"
                class="btn btn-white btn-border pointer btn-submit mr-1 w-100"
                [ngClass]="{ 'payment-active-btn': isPaymentOnline }" (click)="paymentMethod(true)">
                Online card entry
              </button>
            </div>
            <div class="ui-g-6 p-0">
              <button id="ManualCardEntryCheckBox" [value]="!isOnlineCard"
                class="btn btn-white btn-border pointer btn-submit mr-1 w-100"
                [ngClass]="{ 'payment-active-btn': !isPaymentOnline }" (click)="paymentMethod(false)">
                Manual Payment
              </button>
            </div>
          </div>
          <!-- buttons end -->
          <!-- charge card end -->

          <div
            *ngIf="!isPaymentOnline || (!featureIsPayRixEnable && !isGlobalPayEnabled) || (!isPayrixConnected && !isGlobalPayConnected) || showNotesAndPaymentMethod"
            class="ui-g-12 p-0 my-3">
            <div class="flex-start-center field-wrapper">
              <div class="field-icon flex-center-center">
                <i class="far fa-usd-square"></i>
              </div>

              <div class="field-input">
                <label class="font-12 font-600 mb-0">
                  <span>Payment method*</span>
                </label>

                <app-dropdown placeholder="Select" theme="primary" position="bottom" field="name"
                  [disabled]="afterOnlinePayment" scrollHeight="200px" styleClassSelectedView="payment-method-dropdown"
                  id="payment-selection-{{ activePayment.value }}"
                  listId="payment-selection-{{ activePayment.value }}-list" [fontSize]="14"
                  [setPositionDynamically]="false" [disabled]="isArchived" [options]="paymentMethods"
                  [isDropdownIconVisible]="true" [value]="selectedPaymentMethod" (appSelect)="onCardTypeSelect($event)">
                </app-dropdown>
              </div>
            </div>
          </div>

          <!-- Credit card no & security code -->
          <div *ngIf="
              (activePayment.value === 'card' && !isPaymentOnline) || afterOnlinePayment ||
              (activePayment.value === 'card' && paymentId) ||
              (activePayment.value === 'card' && (!isPayrixConnected && !isGlobalPayConnected))
            " class="ui-g-12 p-0 my-3">
            <div class="flex-start-end field-wrapper">
              <div class="ui-g-6 p-0">
                <div class="field-input ml-auto">
                  <label class="font-12 font-600 mb-0 position-relative mb-1">Last 4
                    digits*</label>
                  <app-input type="text" mask="9999" theme="primary" placeholder="Last 4 digits*" class="font-13"
                    id="payment-card-last-4" [hasHoverBorderBottom]="false" [disabled]="disabled || afterOnlinePayment"
                    [hasHoverEffect]="false" (appChange)="handleChange($event, 'card4Digits')"
                    [value]="payment.card4Digits">
                  </app-input>
                </div>
              </div>

              <div class="ui-g-6 p-0">
                <div class="field-input ml-auto">
                  <label class="font-12 font-600 mb-0 position-relative mb-1">Confirmation
                    #</label>
                  <app-input id="payment-card-conf-no" type="text" theme="primary" placeholder="" mask="0*"
                    [patterns]="confirmCardPattern" class="font-13" [hasHoverBorderBottom]="false"
                    [disabled]="disabled || afterOnlinePayment" [hasHoverEffect]="false"
                    (appChange)="handleChange($event, 'cardConfNo')" [value]="payment.cardConfNo">
                  </app-input>
                </div>
              </div>
            </div>
          </div>

          <!-- Check No -->
          <div class="ui-g-12 p-0 mb-3 field-wrapper" *ngIf="activePayment.value === 'cheque'">
            <div class="field-input ml-auto">
              <label class="font-12 font-600 mb-0">{{ dataService.checkTxt }} number*</label>
              <app-input id="payment-cheque-no" type="text" theme="primary" mask="0*" placeholder="0" class="font-14"
                [hasHoverBorderBottom]="false" [disabled]="disabled" [value]="payment.checkNo" [hasHoverEffect]="false"
                (appChange)="handleChange($event, 'checkNo')">
              </app-input>
            </div>
          </div>

          <!-- Amount & Date -->
          <div class="ui-g-12 p-0 mb-3">
            <div class="ui-g-6 p-0 pr-1">
              <div class="flex-start-center field-wrapper">
                <div class="field-icon flex-center-center">
                  <i class="far fa-calendar-alt"></i>
                </div>

                <div class="field-input">
                  <label class="font-12 font-600 mb-0 position-relative" style="top: 4px;">Date</label>
                  <div>
                    <div
                      [ngClass]="{ 'disabled-with-default': isArchived || (isPaymentOnline && isPaymentGatewayConected) || (!changePaymentData && isPaymentDataPrivilgesEnabled)}"
                      class="calendar-input flex-between-center payment-date pointer">
                      <p-calendar id="payment-date" placeholder="Date" styleClass="payment-pointer"
                        [(ngModel)]="payment.paymentDate"
                        [disabled]="isArchived || (isPaymentOnline && isPaymentGatewayConected) || (!changePaymentData && isPaymentDataPrivilgesEnabled)"
                        [readonlyInput]="true" [minDate]="payment?.estimate?.createdAt" [maxDate]="maxDateRange"
                        dateFormat="M d, yy" (onSelect)="onDateTimeChange($event)" #paymentDateTimeEl
                        [appendTo]="'body'" [baseZIndex]="100"></p-calendar>
                      <i class="fal fa-calendar" [ngClass]="{ 'd-none': isArchived }"
                        (click)="(isPaymentDataPrivilgesEnabled && changePaymentData &&
                    paymentDateTimeEl.showOverlay()) || (!isPaymentDataPrivilgesEnabled && paymentDateTimeEl.showOverlay())"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="ui-g-6 p-0 pl-1">
              <div class="flex-start-center field-wrapper">
                <div class="field-icon flex-center-center">
                  <i class="far fa-clock"></i>
                </div>
                <div class="field-input">
                  <label class="font-12 font-600 mb-0 position-relative" style="top: 4px;">Time*</label>
                  <div [ngClass]="{ 'disabled-with-default': isArchived }">
                    <div
                      [ngClass]="{ 'disabled-with-default': isArchived || (isPaymentOnline && isPaymentGatewayConected) }">
                      <kendo-timepicker [(value)]="paymentTime"
                        [disabled]="isArchived || (isPaymentOnline && isPaymentGatewayConected) || (!changePaymentData && isPaymentDataPrivilgesEnabled)"
                        [formatPlaceholder]="{ hour: 'hh', minute: 'mm' }"></kendo-timepicker>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Notes -->
          <div class="ui-g-12 p-zero mt-3">
            <div class="flex-start-center field-wrapper">
              <div class="field-input">
                <div class="form-group mb-0">
                  <app-textarea theme="primary" id="payment-notes" name="notes" [disabled]="isArchived"
                    placeholder="Notes" rows="1" [value]="payment.notes" [fontSize]="14" [floatingLabel]="true"
                    (appChange)="handleChange($event, 'notes')">
                  </app-textarea>
                </div>
              </div>
            </div>
          </div>

          <!-- PayOnline -->
          <div [hidden]="afterOnlinePayment"
            *ngIf="activePayment.value === 'card' && isPaymentOnline && isPaymentGatewayConected"
            class="ui-g-12 p-zero mb-10px pt-3">
            <label class="font-12 font-600 mb-4px">Pay online</label>
            <div class="form-group font-14 mb-20 notes">
              <button [disabled]="!payment?.collectedAmount || isStateRestricted()" id="OnlineCardEntryButton"
                (click)="openScreen()" class="btn btn-primary pointer btn-submit mr-1 w-100">
                Pay Online - card entry
                <i *ngIf="opening" class="fal fa-spinner rotate"></i>
              </button>
            </div>
          </div>
          <!-- Payonline end -->

        </div>

        <!-- Start Right Panel -->
        <div class="ui-g-4 p-2 right-box">
          <div id="bulk-pay-statement-total-invoice" class="ui-g-12 p-0 pt-1 pb-1 flex-between-center">
            <span class="font-bold">Total invoices value</span>
            <span class="font-bold">{{ statementTotal.total | currency: usd }}</span>
          </div>

          <div id="bulk-pay-statement-paid" class="ui-g-12 p-0 pt-1 pb-1 flex-between-center border-bottom">
            <span class="">Paid to date</span>
            <span class=""> {{ statementTotal.paid | currency: usd }}</span>
          </div>

          <div id="bulk-pay-statement-outstanding-inv" class="ui-g-12 p-0 pt-1 pb-1 flex-between-center">
            <span class="font-bold">Outstanding Invoice amount</span>
            <span class="font-bold">{{ statementTotal.due | currency: usd }}</span>
          </div>

          <div id="bulk-pay-statement-applied-payment" class="ui-g-12 p-0 pt-1 pb-1 flex-between-center">
            <span class="">Applied Payment Amount</span>
            <span class="">{{ statementTotal.applied + statementTotal.priorAppliedPayment | currency: usd }}</span>
          </div>

          <div id="bulk-pay-statement-applied-payment" class="ui-g-12 p-0 pt-1 pb-1 pl-4 flex-between-center">
            <span class="">Prior un-applied payments</span>
            <span class="">{{ statementTotal.priorAppliedPayment || 0 | currency: usd }}</span>
          </div>

          <div id="bulk-pay-statement-applied-payment" class="ui-g-12 p-0 pt-1 pb-1 pl-4 flex-between-center">
            <span class="">New payments</span>
            <span class="">{{ statementTotal.applied || 0 | currency: usd }}</span>
          </div>

          <!-- <div id="bulk-pay-statement-unapplied-payment"
            class="ui-g-12 p-0 pt-1 pb-1 flex-between-center border-bottom">
            <span class="">Unapplied Payment Amount</span>
            <span class="">{{ statementTotal.notApplied | currency: usd }}</span>
          </div> -->

          <div id="bulk-pay-statement-balance" class="ui-g-12 p-0 pt-1 pb-1 flex-between-center">
            <span class="font-bold">Balance due</span>
            <span class="font-bold">{{ remainingBalance | currency: usd }}</span>
          </div>
        </div>
        <!-- End Right Panel -->
      </div>
    </div>
  </div>

  <div class="ui-g-12 p-zero dialog-footer">
    <div class="ui-g-8 mark-paid p-zero"></div>

    <div class="ui-g-4 p-zero text-right float-right payment-add-footer">
      <button id="payment-btn-cancel" class="btn btn-white btn-border pointer btn-submit mr-1"
        (click)="closePaymentModal($event)">Cancel</button>

      <button id="payment-btn-save" class="btn btn-primary btn-submit" [disabled]="isStateRestricted() || isProcessing"
        (click)="onSubmit(true)">
        <span [ngClass]="{ 'pr-2': isProcessing }">Save</span>
        <i *ngIf="isProcessing" class="fal fa-spinner rotate"></i>
      </button>
    </div>
  </div>
</div>
